(() => {
  function initPth24eVideoOptimization() {
    const root = document.querySelector('.pth24d-root');
    if (!root || root.dataset.pth24eVideoOptimizationReady === 'true') return;

    const heading = root.querySelector('#pth24e-video-heading');
    const videoSection = heading ? heading.closest('.pth253d-video-section') : null;
    if (!videoSection) return;

    root.dataset.pth24eVideoOptimizationReady = 'true';

    const comparison = root.querySelector('.pth253d-comparison');
    const firefighter = root.querySelector('.pth253d-proof-profile');
    if (comparison && firefighter) {
      firefighter.before(videoSection);
    } else if (comparison) {
      comparison.after(videoSection);
    }

    const slider = videoSection.querySelector('.pth253d-video-slider');
    const viewport = videoSection.querySelector('[data-pth24d-video-viewport]');
    const cards = Array.from(videoSection.querySelectorAll('.pth253d-video-card'));

    if (cards.length > 3 && slider) {
      const wrap = document.createElement('div');
      wrap.className = 'pth24e-video-more-wrap';

      const button = document.createElement('button');
      button.className = 'pth24e-video-more';
      button.type = 'button';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'View more videos';
      wrap.appendChild(button);
      slider.after(wrap);

      const setExpanded = (expanded) => {
        if (!expanded) {
          cards.slice(3).forEach((card) => {
            const video = card.querySelector('[data-pth24d-video-element]');
            if (video && !video.paused) video.pause();
          });
        }

        videoSection.classList.toggle('pth24e-video-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Show fewer videos' : 'View more videos';

        window.requestAnimationFrame(() => {
          if (!expanded && viewport) {
            const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
            if (viewport.scrollLeft > maxScroll) viewport.scrollLeft = maxScroll;
          }
          window.dispatchEvent(new Event('resize'));
        });
      };

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        setExpanded(!expanded);
      });

      setExpanded(false);
    }

    videoSection.classList.add('pth24e-video-ready');
    window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPth24eVideoOptimization, { once: true });
  } else {
    initPth24eVideoOptimization();
  }
})();
